import { render, staticRenderFns } from "./DecoItemCanvasComponent.vue?vue&type=template&id=9b073bee&"
import script from "./DecoItemCanvasComponent.vue?vue&type=script&lang=ts&"
export * from "./DecoItemCanvasComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DecoItemCanvasComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports